// extracted by mini-css-extract-plugin
module.exports = {"label":"dd31006766--label--pQeup","silver":"dd31006766--silver--jHk7U","orange":"dd31006766--orange--jZOQw","gray":"dd31006766--gray--xQvpr"};